/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["kaa",[["AM","PM"]],u,[["Е","Д","С","С","П","Ж","Ш"],["Екш","Дүй","Сий","Сәр","Пий","Жум","Шем"],["екшемби","дүйшемби","сийшемби","сәршемби","пийшемби","жума","шемби"],["Ек","Дү","Си","Сә","Пи","Жу","Ше"]],u,[["Я","Ф","М","А","М","И","И","А","С","О","Н","Д"],["янв","фев","мар","апр","май","июн","июл","авг","сен","окт","ноя","дек"],["январь","февраль","март","апрель","май","июнь","июль","август","сентябрь","октябрь","ноябрь","декабрь"]],[["Я","Ф","М","А","М","И","И","А","С","О","Н","Д"],["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"]],[["б. э. ш.","б. э."],u,["бизиӊ эрамызға шекемги","бизиӊ эрамыздыӊ"]],1,[6,0],["y-MM-dd","y MMM d","y MMMM d","y MMMM d, EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[".",",",";","%","+","-","E","×","‰","∞","NaN",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],u,u,u,{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
